var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_material-place",
    "data-name": "Icon material-place",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.25,
    height: 37.5,
    viewBox: "0 0 26.25 37.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-place-2",
    "data-name": "Icon material-place",
    d: "M20.625,3A13.115,13.115,0,0,0,7.5,16.125C7.5,25.969,20.625,40.5,20.625,40.5S33.75,25.969,33.75,16.125A13.115,13.115,0,0,0,20.625,3Zm0,17.813a4.688,4.688,0,1,1,4.688-4.688A4.689,4.689,0,0,1,20.625,20.813Z",
    transform: "translate(-7.5 -3)",
    fill: "#f7f2ee"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact2);
export default __webpack_public_path__ + "static/media/contact2.41b445c8.svg";
export { ForwardRef as ReactComponent };